<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer036">
<p class="Text"><span class="CharOverride-2">And God said, “Let there be dog,” and there </span><span class="CharOverride-2">was dog. 
			</span></p>
<p class="Text"><span class="CharOverride-2">God saw that dog was good, and said, </span></p>
<p class="Text"><span class="CharOverride-2">“Who’s a good dog?” </span></p>
<p class="Text"><span class="CharOverride-2">And it was dog. Yes it was.</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyle-Disabled" id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_dog.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer037">
<p class="Text"><span class="CharOverride-2">“Why should we care about beauty, anyway?”</span> <span class="CharOverride-2">she asked the dark. 
			</span></p>
<p class="Text"><span class="CharOverride-2">“Because creation is temporary,” it replied,</span> <span class="CharOverride-2">“and destruction is forever.”</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer041">
<p class="Text l3"><span class="CharOverride-2">Ownership is an illusion, the cat knew. Nothing is forever.  </span></p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer038">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_edge.jpg"/>
</div>
</div>
<p class="Text2 l3"><span class="CharOverride-2"> They needed to learn.    </span></p>
<p class="Text l3"><span class="CharOverride-2"> He began pushing another glass toward the table’s edge.</span></p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_edge1.jpg"/>
</div>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer042">
<p class="Text"><span class="CharOverride-2">“Why is the world so cruel?” she asked. </span></p>
<p class="Text"><span class="CharOverride-2">“To remind us to be kind,” said the Oracle. </span></p>
<p class="Text"><span class="CharOverride-2">“Really?” </span></p>
<p class="Text"><span class="CharOverride-2">“No. But it’s a good enough reason to try.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer043">
<p class="Text"><span class="CharOverride-2">He sat, alone. </span></p>
<p class="Text"><span class="CharOverride-2">No one had come to his Halloween party. </span></p>
<p class="Text"><span class="CharOverride-2">That or all his guests had dressed as ghosts</span> <span class="CharOverride-2">and their costumes were amazing.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer044">
<p class="Text"><span class="CharOverride-2">“I’m dead? It’s over?” he asked. </span></p>
<p class="Text"><span class="CharOverride-2">“Yes. What did you think?” asked Death. </span></p>
<p class="Text"><span class="CharOverride-2">“Of life?” </span></p>
<p class="Text"><span class="CharOverride-2">“Yes.” </span></p>
<p class="Text"><span class="CharOverride-2">“Why?” </span></p>
<p class="Text"><span class="CharOverride-2">“I’ve always wanted to try it.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer045">
<p class="Text"><span class="CharOverride-2">In faded sheets with fraying ends, he thought of love and sun and friends. </span></p>
<p class="Text"><span class="CharOverride-2">His share of days and where they went. </span></p>
<p class="Text"><span class="CharOverride-2">All gone now. </span></p>
<p class="Text"><span class="CharOverride-2">But so well spent.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer047">
<p class="Text"><span class="CharOverride-2">He pulled the sheet over his head, thinking it</span> <span class="CharOverride-2">would make him a ghost. </span></p>
<p class="Text"><span class="CharOverride-2">When he tripped on the hem at the top of the</span> <span class="CharOverride-2">stairs, it did.</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer046">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_sheet.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer048">
<p class="Text"><span class="CharOverride-2">“I suppose this is goodbye.” </span></p>
<p class="Text"><span class="CharOverride-2">“Maybe, but we’ll always have Rome.” </span></p>
<p class="Text"><span class="CharOverride-2">“We never went to Rome.” </span></p>
<p class="Text"><span class="CharOverride-2">“I know. Regrets last longer than memories.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer049">
<p class="Text"><span class="CharOverride-2">Desperate to salve the pain, she stole his heart for her own. </span></p>
<p class="Text"><span class="CharOverride-2">But for all her love, it wouldn’t beat for her. </span></p>
<p class="Text"><span class="CharOverride-2">Or at all.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer050">
<p class="Text"><span class="CharOverride-2">“How can I feel strong?” she asked.</span></p>
<p class="Text"><span class="CharOverride-2">“This hate potion would do,” the witch said. </span></p>
<p class="Text"><span class="CharOverride-2">“Oh. How can I BE strong?”</span></p>
<p class="Text"><span class="CharOverride-2">“Don’t take the hate potion.”</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_littledeath.png"/>
</div>
</div>
<div id="_idContainer052">
<p class="Text2 l1"><span class="CharOverride-2">The small hooded figure perched on her vanity. </span></p>
<p class="Text l1"><span class="CharOverride-2">“Death? Damn. I’ll miss my date,” she said. </span></p>
<p class="Text l1"><span class="CharOverride-2">“No, I’m Little Death. The date will go fine.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer053">
<p class="Text"><span class="CharOverride-2">“I just want someone to love me forever,” </span><span class="CharOverride-2">he said. </span></p>
<p class="Text"><span class="CharOverride-2">“I will,” she promised, “forever and always.” </span></p>
<p class="Text"><span class="CharOverride-2">“Oh,” he said, “I mean someone else.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer054">
<p class="Text"><span class="CharOverride-2">When they came from the stars, it was to take our hearts. </span></p>
<p class="Text"><span class="CharOverride-2">But it was too late. </span></p>
<p class="Text"><span class="CharOverride-2">One look at us told them that we hadn’t any left.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer055">
<p class="Text"><span class="CharOverride-2">“Are we alone in the universe?” she asked. </span></p>
<p class="Text"><span class="CharOverride-2">“Yes,” said the Oracle. </span></p>
<p class="Text"><span class="CharOverride-2">“So there’s no other life out there?” </span></p>
<p class="Text"><span class="CharOverride-2">“There is. They’re alone too.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer056">
<p class="Text"><span class="CharOverride-2">They watched as the meteor lit the sky. </span></p>
<p class="Text"><span class="CharOverride-2">“Is this the end?” one asked. </span></p>
<p class="Text"><span class="CharOverride-2">“Only of us,” said the other. </span></p>
<p class="Text"><span class="CharOverride-2">“Then what?” </span></p>
<p class="Text"><span class="CharOverride-2">“Something better.”</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-1" src="image/asf_end.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer058">
<p class="Text"><span class="CharOverride-2">“Are you here to conquer Earth?”</span></p>
<p class="Text"><span class="CharOverride-2">The aliens exchanged a look. </span></p>
<p class="Text"><span class="CharOverride-2">“No,” one said, “this is more like an<br/> intervention. You guys need to relax.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer059">
<p class="Text"><span class="CharOverride-2">Her life story was being written in a different</span> <span class="CharOverride-2">genre than she’d thought. </span></p>
<p class="Text"><span class="CharOverride-2">She’d expected drama. Maybe romance. </span></p>
<p class="Text"><span class="CharOverride-2">Dystopian was a surprise.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer060">
<p class="Text"><span class="CharOverride-2">“Don’t worry; we’re here,” said the story police. </span></p>
<p class="Text"><span class="CharOverride-2">“Why?” asked the writer. </span></p>
<p class="Text"><span class="CharOverride-2">“To present our opinions as fact.” </span></p>
<p class="Text"><span class="CharOverride-2">“No thank you.” </span></p>
<p class="Text"><span class="CharOverride-2">“Oh, we insist.”</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer061">
<p class="Text"><span class="CharOverride-2">“This magic pen sucks,” he said. “It only writes garbage!”</span><span class="CharOverride-2"> </span></p>
<p class="Text"><span class="CharOverride-2">“The pen isn’t magic,” said the wizard. “The</span> <span class="CharOverride-2">garbage was inside you all along.”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Small_Fiction_ebook1.vue?0dee144c